import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { AddTime} from '../table/table.component';

interface Food {
  value: string;
  viewValue: string;
}
@Component({
  selector: 'app-popup',
  templateUrl: './popup.component.html',
  styleUrls: ['./popup.component.css']
})
export class PopupComponent implements OnInit {

  changed=true;
  result : any ={
    unit:'',
    amount:'',
    schedule:'',
    type:'',
    description:''
  }

  constructor(
    public dialogRef: MatDialogRef<PopupComponent>,
    @Inject(MAT_DIALOG_DATA) public data:AddTime) {
      if(this.data.mode !='Add'){
        if(this.data.for == 'feed' && this.data.feedData){
          this.result.schedule = this.data.feedData.feedSchedule && this.data.feedData.feedSchedule.id ? this.data.feedData.feedSchedule.id : '';
          this.result.amount = this.data.feedData.feedAmount && this.data.feedData.feedAmount.id ? this.data.feedData.feedAmount.id : '';
          this.result.unit = this.data.feedData.feedUnit && this.data.feedData.feedUnit.id ? this.data.feedData.feedUnit.id : '';
        }
        else if(this.data.for == 'med' && this.data.medData){
          this.result.schedule = this.data.medData.medicationSchedule && this.data.medData.medicationSchedule.id ? this.data.medData.medicationSchedule.id : '';
          this.result.amount = this.data.medData.medicationAmount && this.data.medData.medicationAmount.id ? this.data.medData.medicationAmount.id : '';
          this.result.unit = this.data.medData.medicationUnit && this.data.medData.medicationUnit.id ? this.data.medData.medicationUnit.id : '';
          this.result.type = this.data.medData.medicationType && this.data.medData.medicationType.id ? this.data.medData.medicationType.id : '';
        }
      }
    }
    
  onNoClick(): void {

    this.dialogRef.close();
  }
  onYesClick():void{
    this.dialogRef.close(this.result);
  }
  resultAmount(event:any){
    this.result.amount=event.value;
   
  }
  resultSchedule(event:any){
   
    this.result.schedule=event.value;
  }
  resultUnit(event:any){
   
    this.result.unit=event.value;
  }
  resultType(event:any){
    
    this.result.type=event.value;
  }
  show(){
    console.log(this.data);
    
  }
  formCheck() {
    if (this.data.for == 'med' && this.result.type && this.result.type != '') {
      return false;
    }
    if (this.result.unit && this.result.amount && this.result.schedule && this.result.unit != '' && this.result.amount != '' && this.result.schedule != '') {
      return false;
    }
    return true;
  }
  ngOnInit(): void {
  }

}
